import { createSlice } from "@reduxjs/toolkit";

import { IMarketStore } from "../types";

const initialState: IMarketStore = {
  markets: [],
};

export const marketSlice = createSlice({
  name: "market",
  initialState,
  reducers: {
    setMarkets: (state, { payload }) => {
      state.markets = payload;
    },
  },
});

export const { setMarkets } = marketSlice.actions;
